// Import: Middleware Action & Custom Types
import { CLEAN_PORTABILITY_ACTION, CLEAN_PORTABILITY_ACTION_ERROR } from '_models/redux/types';

// Action function
export const cleanPortabilityAction = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      type: CLEAN_PORTABILITY_ACTION,
      payload: undefined,
    });
  } catch (e) {
    dispatch({
      type: CLEAN_PORTABILITY_ACTION_ERROR,
      payload: undefined,
    });
  }
};
